import { postRequest } from "./axios";
import {LOG_ACTION_URL, LOG_COOKIE_AGREE_URL} from "./constants";

export function logActionRequest(phone, text) {

  let isNumber = typeof phone === 'number';
  let isString = typeof phone === 'string';

  if (isString) {
    phone = phone.replace(/\D/g, '');
  } else if (isNumber) {
    phone = String(phone);
  }

  return postRequest(LOG_ACTION_URL, {
    phone: phone,
    text: text
  }, {
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
}

export function recordCookieAgreeRequest(datetime, userId = null) {
  return postRequest(LOG_COOKIE_AGREE_URL, {
    datetime: datetime,
    userId: userId
  }, {
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
}
